// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"ae05f597","90":"54b19fe4","173":"e0ad7ed1","238":"dd4841de","453":"15da41cd","743":"5e889f87"}[chunkId] + ".chunk.js";
};